import { Club } from '../club/club';
import { JWTToken } from './jwt-token';
import { Permissions } from './permissions';

/**
 * Blueprint for the authenticated user entity.
 */
export class AuthenticatedUser {
  public iri: string;
  public id: number;
  public username: string;
  public firstName?: string;
  public lastName?: string;
  public email: string;
  public type: string;
  public enabled: boolean;
  public tokenLifetime: number;
  public clubs?: Array<Club> = [];
  public forcePasswordChange?: boolean;
  public openReminderCount: number;

  public permissions: Permissions;
  public jwtToken: JWTToken;

  constructor(user, permissions) {
    this.iri = user['@id'];
    this.id = user.id;
    this.username = user.username;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.email = user.email;
    this.type = user.type;
    this.enabled = user.enabled;
    this.tokenLifetime = user.tokenLifetime;
    this.clubs = user.clubs.filter((club: Club) => club !== null || club !== undefined);
    this.forcePasswordChange = user.forcePasswordChange;
    this.openReminderCount = user.openReminderCount;

    this.permissions = new Permissions(permissions);
  }

  public set setJWTToken(token: JWTToken) {
    this.jwtToken = token;
  }

  public get isAdmin(): boolean {
    return this.type === 'Admin';
  }

  public get isClubAdmin(): boolean {
    return this.type === 'ClubAdmin';
  }

  public get isCallCenterAgent(): boolean {
    return this.type === 'CallCenterAgent';
  }

  public get isCountryManager(): boolean {
    return this.type === 'CountryManager';
  }

  public get isTicketAgent(): boolean {
    return this.type === 'TicketAgent';
  }

  public get isAdminType(): boolean {
    return this.isAdmin || this.isClubAdmin || this.isCountryManager;
  }

  public get canAddClubAttributes(): boolean {
    return this.permissions.clubAttributes.add;
  }

  public get canListClubs(): boolean {
    return this.permissions.club.list;
  }

  public get canListUsers(): boolean {
    return this.permissions.user.list;
  }

  public get canEditUser(): boolean {
    return this.permissions.user.add;
  }

  public get canSeeSettings(): boolean {
    return this.permissions.club.settings;
  }

  public get canTransferToCampai(): boolean {
    return this.permissions.campaiMembership.transfer;
  }

  public get canAddMembership(): boolean {
    return this.permissions.membership.add;
  }

  public get canDeleteMembership(): boolean {
    return this.permissions.membership.delete;
  }
}
